import $axios from "../api/accessor";
import { $api } from "../api/api";

export const InvoiceService = {
  async uploadInvoice(id: number, payload: any) {
    let response = await $axios
      .post($api("upload_invoice", { id }), payload, {})
      .catch((err) => {
        throw err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async getPackagesUpdate(id: number) {
    let response = await $axios
      .get($api("get_packagesUpdate", { id }), {})
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
};
